"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultSchema = void 0;
const zod_1 = require("zod");
exports.SearchResultSchema = zod_1.z.object({
    chunkId: zod_1.z.string(),
    textContent: zod_1.z.string(),
    score: zod_1.z.number(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
});
//# sourceMappingURL=search-results.js.map